import React from "react";
import { Col, Form } from "react-bootstrap";
import { useDynamicTextAreaHeight } from "../../utils/hooks";

export function EditItemForm({ formData, formSchema, onChange}){

  let [textContainerRef, textareaRef] = useDynamicTextAreaHeight(false, formData.content)

  // useEffect(()=>{
  //   textRef.current.style.height = textRef.current.scrollHeight 
  // }, [formData])

  return (
    <Form>
      {formSchema.map((i, idx)=>{
        return (
          <Form.Group key={idx} ref={i.name === 'content'? textContainerRef: null} >
            <Form.Label col="true" sm={2}>{i.name}</Form.Label>
            <Col>
              <Form.Control 
                key={idx}
                ref={i.name === 'content'? textareaRef: null}
                id={i.name} 
                // defaultValue={formData[i.name]} 
                {...i}
                value={formData[i.name]||''}
                onChange={(evt)=>
                  onChange(evt.target.value, i.name)
                } />
            </Col>
          </Form.Group>
        )
      })}
    </Form>
  )
}